(function () {
    "use strict";

    // @ngInject
    function NewAddPreferredContactControllerCtor($scope, $modalInstance, $injector, $q, $translate, ContactsManager, UsersManager, UserService, _, CompanyService, ModelFactory, NetworkManager, GoogleAPIService, AnalyticsService, SearchablesManager, config, ValidationsManager) {

        this.constructor.$super.call(this, $scope, $modalInstance, $injector, $translate, UsersManager, UserService, _, CompanyService, ModelFactory, NetworkManager, GoogleAPIService, AnalyticsService, SearchablesManager, ValidationsManager, config);
        this.__objectType = 'NewAddPreferredContactController';

        this.ContactsManager = ContactsManager;
        this.$q = $q;
        this.config = config;

        this.titleText = $translate.instant("DASHBOARD.CONTACTS.ADD_PREFERRED_VENDOR_CONTACT._HEADER_TITLE_");
         this.subTitleText = '';
        this.ctaText = $translate.instant("ADD_USER_DIALOG.NEW_ADD_USER_MODAL._ADD_");

        this.isVendor = true;
        this.isVendorEditDisabled = true;
        // this.showOptionalFields = false;
        this.user.system_user_type = 'vendor';

        this.isSuggestFromVendorContacts = true;
        this.isSuggestFromGmailContacts = true;

    }

    Controllers.NewAddPreferredContactController = Class(Controllers.NewAddUserController, {

        constructor: NewAddPreferredContactControllerCtor,

        saveUser: function saveUser() {
            var defer = this.$q.defer();
            var user = this.user;

            var contact = this.ContactsManager.convertUserToContact(user);

            this.ContactsManager.savePreferredVendorContact(contact, true)
                .then(function success(resp) {
                    this.AnalyticsService.track(this, "added contact as preferred vendor",
                        {
                            new_member_email: user.email,
                            source: this.config.source
                        });
                    defer.resolve(contact);
                }.bind(this))
                .catch(function error(resp) {
                    defer.reject(resp);
                }.bind(this));
            return defer.promise;
        },

        handleUserFromDb: function handleUserFromDb(dbUser){
            if (dbUser.email){
                if (!dbUser.isVendor()) {
                    this.user.email = null;
                    return;
                }
                this.user = dbUser;
            }
            else{ //user doesn't exist
                this.user._id = null; // user doesn't exist yet (it will also remove the avatar).
            }
        },

    });
}());

